import { render, staticRenderFns } from "./LoginOrSignupPopup.vue?vue&type=template&id=ae1e65de&"
import script from "./LoginOrSignupPopup.vue?vue&type=script&lang=js&"
export * from "./LoginOrSignupPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports